export interface ApiHubSocketsInfo {
  base_url: string;
}

export async function apiGetHubServer(): Promise<ApiHubSocketsInfo> {
  const results = await fetch(`${process.env.REACT_APP_HUB_URL}`, {
    credentials: 'include'
  });

  if (results.ok) {
    const json = await results.json();

    return json;
  } else {
    throw results;
  }
}
